import React, { PropTypes } from 'react'
import AppBar from 'react-toolbox/lib/app_bar'
import Navigation from 'react-toolbox/lib/navigation'
import styles from './styles'

const MainAppBar = (props) => {
  const { user, isProjectLeader } = props
  let links = [{ href: '#/timesheet', icon: 'timelapse', label: '工時表' }]
  if (user !== null && (user.role === 'admin' || user.role === 'manager' || isProjectLeader)) {
    if (user.role === 'admin') {
      links.push({ href: '#/admin', icon: 'person', label: '管理者' })
    }
    links.push({ href: '#/project', icon: 'assignment', label: '週報審核' })
  }

  // links.push({ href: '#/user', icon: 'home', label: '使用者設定' });
  links.push({ href: '#/logout', icon: 'exit-to-app', label: '登出' })


  if (user === null) {
    links = [
      { href: '#', icon: 'timelapse', label: '工時表系統' },
    ]
  }

  return (
    <div className={styles.appbar} >
      <AppBar >
        <Navigation className={styles.appbarNav} type="horizontal" routes={links} />
      </AppBar>
    </div>
  )
}

MainAppBar.propTypes = {
  user: PropTypes.object,
  isProjectLeader: PropTypes.bool,
}

export default MainAppBar



// WEBPACK FOOTER //
// ./src/app/components/appbar/index.jsx